import styled from 'styled-components';

const Logo = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  width: 60px;
  height: 25px;
`;

export { Logo };
